import { FieldType } from '@app/src/common/components/form/MobxFieldControl';
import { FormControlType } from '@app/src/common/model/FormControls';
import { IFormField } from '@app/src/common/model/FormField';

const ForgotPasswordFormFields = {
  email: {
    id: 'email',
    name: 'Email',
    label: 'forgot.pass.form.email.label'
  }
};

export const forgotPasswordFormConfig: IFormField[] = [
  {
    name: 'email',
    label: 'forgot.pass.form.email.label',
    type: FieldType.EMAIL,
    control: FormControlType.INPUT,
    required: true
  }
];

export default ForgotPasswordFormFields;
